<template>
  <div @click="over">
    <!-- 左侧菜单栏 -->
    <NavBar></NavBar>
    <!-- 头部 -->
    <HeadBar></HeadBar>
    <!-- 内容 -->
    <MainContent v-loading="loding"></MainContent>
  </div>
</template>

<script>
import NavBar from './NavBar/NavBar'
import HeadBar from './HeadBar/HeadBar'
import MainContent from './MainContent/MainContent'
import { mapState } from 'vuex'
export default {
  name: 'Home',
  components: {
    NavBar,
    HeadBar,
    MainContent
  },
  computed: {
    ...mapState({
      loding: state => state.app.loding
    })
  },
  props: {},
  data () {
    return {
    }
  },
  methods: {
    over (event) {
      let myPanel = document.getElementById('myPanel')
      let dropdown = document.getElementById('dropdown-menu')
      let myTissue = document.getElementById('myTissue')
      let dropdownT = document.getElementById('dropdown-tissue')
      if (myPanel && !myPanel.contains(event.target) && !dropdown.contains(event.target)) { // 这句是说如果我们点击到了id为myPanel以外的区域
        this.$store.commit('dropdownMenu', false)
      }
      if (myTissue && !myTissue.contains(event.target) && !dropdownT.contains(event.target)) { // 这句是说如果我们点击到了id为myTissue以外的区域
        this.$store.commit('dropdownTissue', false)
      }
    }
  }
}
</script>
<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// src/views/Home.vue